import React, {useEffect, useState} from 'react';
import {Image, Layer, Stage} from "react-konva";
import useImage from "use-image";
import BackgroundProductImage from "../../../shopify/components/product-image/background-product-image";
import BackgroundRectangleShape from "../design-editor/konva-editor/background-rectangle-shape";
import BackgroundVariantImage from "./background-variant-image";
import GridLayer from "../design-editor/konva-editor/grid-layer";

function downloadURI(uri, name) {
    let link = document.createElement('a');
    link.download = name;
    link.href = uri;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

const ViewSingleVariantDesign = ({
                                     designVariant,
                                     settings,
                                     selectedImageDetail,
                                     imageDetail,
                                     variantIndex,
                                     showGrid
                                 }) => {
    const [initialStep, setInitialStep] = useState(true);
    const stageRef = React.useRef(null);
    const backgroundRef = React.useRef(null);
    const [stagePos, setStagePos] = useState(null);
    const [stageScale, setStageScale] = useState(1);
    const [stageSize, setStageSize] = useState(null);
    const [showStage, setShowStage] = useState(false);
    const gridLayerRef = React.useRef();

    useEffect(() => {
        if (initialStep) {
            initStage();
        }
    }, [initialStep]);

    useEffect(() => {
        showHideGrid(showGrid);
    }, [showGrid]);

    const initStage = () => {
        fitStageIntoParentContainer(settings);
        setShowStage(true);
        refreshStage();
    }

    useEffect(() => {
        if (selectedImageDetail && selectedImageDetail?.id === imageDetail?.id) {
            handleExport();
        }
    }, [selectedImageDetail]);

    const refreshStage = (triggerDownloadImage = false) => {
        setTimeout(() => {
            const stage = stageRef.current;

            if (stage) {
                stage.draw();
            }
        }, 20);
    }

    const fitStageIntoParentContainer = (settings) => {
        const stage = stageRef.current;
        let container = document.querySelector('#stage-parent');
        // @ts-ignore
        let containerWidth = container?.offsetWidth * 1;
        let scale = containerWidth / settings?.width;

        setStageScale(scale);

        stage.width(settings?.width * scale);
        stage.height(settings?.height * scale);
        stage.scale({x: scale, y: scale});

        setStageSize({width: stage?.width(), height: stage?.height()});
    }

    const handleExport = () => {
        showHideGrid(false);
        const pixelRatio = 100 / (stageScale * 100);
        const uri = stageRef.current.toDataURL({
            pixelRatio: pixelRatio
        });

        downloadURI(uri, designVariant?.imageFileName);
        showHideGrid(true);
    };

    const showHideGrid = (showGrid) => {
        if (gridLayerRef && gridLayerRef.current) {
            // @ts-ignore
            gridLayerRef.current.visible(showGrid);
        }
    }

    return (
        <>

            <div className="variant-image-stage-container m-2">
                <div id="stage-parent"
                     className="flex justify-start p-4">

                    <Stage width={settings?.width} height={settings?.height}
                           style={{'backgroundColor': '#FFFFFF'}}
                           className="flex justify-start border border-gray-800 shadow-lg"
                           draggable={false}
                           listening={false}
                           perfectDrawEnabled={false}
                           ref={stageRef}
                           scaleX={stageScale}
                           scaleY={stageScale}
                           x={stagePos?.x}
                           y={stagePos?.y}>

                        {showStage &&
                            <>

                                <Layer>
                                    <BackgroundRectangleShape
                                        backgroundRef={backgroundRef}
                                        background={settings?.background}
                                        stageWidth={settings?.width}
                                        stageHeight={settings?.height}/>
                                </Layer>

                                <Layer>
                                    <BackgroundVariantImage
                                        key={`variant-image-${variantIndex}`}
                                        imageDetail={imageDetail}
                                        settings={settings}/>
                                </Layer>

                                <Layer ref={gridLayerRef}>
                                    <GridLayer
                                        stageWidth={settings?.width}
                                        stageHeight={settings?.height}/>
                                </Layer>


                            </>
                        }

                    </Stage>
                </div>
            </div>

        </>
    )
}

export default ViewSingleVariantDesign
